"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CustomChargeStore = require("../../../stores/CustomChargeStore.jsx");

var _CustomChargeStore2 = _interopRequireDefault(_CustomChargeStore);

var _CartStore = require("../../../stores/CartStore.jsx");

var _CartStore2 = _interopRequireDefault(_CartStore);

var _Utility = require("../../../utils/Utility.jsx");

var Utils = _interopRequireWildcard(_Utility);

var _reactTooltip = require("react-tooltip");

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DELIVERY = "Delivery";
var PICKUP = "PickUp";
var CURBSIDEPICKUP = "CurbsidePickUp";
var DINEIN = "DineIn";

var CustomChargePriceView = function (_React$Component) {
    _inherits(CustomChargePriceView, _React$Component);

    function CustomChargePriceView(props) {
        _classCallCheck(this, CustomChargePriceView);

        var _this = _possibleConstructorReturn(this, (CustomChargePriceView.__proto__ || Object.getPrototypeOf(CustomChargePriceView)).call(this, props));

        _this.state = {
            orderType: '',
            isCurbsidePickup: '',
            isCouponApplied: false
        };

        return _this;
    }

    _createClass(CustomChargePriceView, [{
        key: "UNSAFE_componentWillMount",
        value: function UNSAFE_componentWillMount() {
            var _this2 = this;

            this.setState({
                orderType: this.props.orderType,
                isCurbsidePickup: _CartStore2.default.getIsPreferCurbsideEnabled(),
                isCouponApplied: _CartStore2.default.getCouponCode() ? true : false
            }, function () {

                var orderType = null;
                if (_this2.isCurbsidePickUpEnabled()) {
                    orderType = CURBSIDEPICKUP;
                } else {
                    orderType = _this2.state.orderType;
                }

                _CartStore2.default.loadDefaultFixedOptionalChargeValue(orderType);
            });
        }
    }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this3 = this;

            var curbsidePickup = _CartStore2.default.getIsPreferCurbsideEnabled();
            var preCurbsidePickup = this.state.isCurbsidePickup;
            var preCouponApplied = this.state.isCouponApplied;
            var isCouponApplied = _CartStore2.default.getCouponCode() ? true : false;

            if (nextProps.orderType != this.props.orderType || preCurbsidePickup != curbsidePickup || preCouponApplied != isCouponApplied) {

                this.setState({
                    orderType: nextProps.orderType,
                    isCurbsidePickup: curbsidePickup,
                    isCouponApplied: isCouponApplied
                }, function () {

                    var orderType = null;
                    if (_this3.isCurbsidePickUpEnabled()) {
                        orderType = CURBSIDEPICKUP;
                    } else {
                        orderType = _this3.state.orderType;
                    }

                    _CartStore2.default.loadDefaultFixedOptionalChargeValue(orderType);
                });
            }
        }
    }, {
        key: "isCurbsidePickUpEnabled",
        value: function isCurbsidePickUpEnabled() {

            // check the ordertype is PickUp and Curbside PickUp option is selected
            if (this.state.orderType == PICKUP && _CartStore2.default.getIsPreferCurbsideEnabled()) {
                return true;
            } else {
                return false;
            }
        }

        // Fixed charge type

    }, {
        key: "getCustomChargesFixedStructure",
        value: function getCustomChargesFixedStructure() {

            if (_CustomChargeStore2.default.isCustomChargeConfigured()) {

                var orderType = null;
                if (this.isCurbsidePickUpEnabled()) {
                    orderType = CURBSIDEPICKUP;
                } else {
                    orderType = this.state.orderType;
                }

                var fixedCharge = _CustomChargeStore2.default.getCustomChargeConfig(orderType, "F");

                // discounted subtotal
                var totalValue = _CartStore2.default.getCartSubTotalWithDiscountRounded();

                // // set the fixed charge fee in cart store
                // CartStore.setCustomChargeFixedFee(fixedCharge, totalValue);

                if (fixedCharge && fixedCharge.length > 0) {

                    var i = 0;
                    return fixedCharge.map(function (charge) {

                        var chargeDesc = charge.desc;

                        var chargeTypeValues = charge.typeDetails.values;

                        // total calculated fixed charge fee
                        var chargeFee = _CustomChargeStore2.default.getCustomChargeFeeRounded(chargeTypeValues, totalValue);

                        var descComponent = null;
                        if (!Utils.isEmpty(chargeDesc)) {
                            descComponent = _react2.default.createElement(
                                "span",
                                null,
                                _react2.default.createElement(
                                    "a",
                                    { "data-tip": chargeDesc, className: 'color-styl tooltip-button',
                                        style: { cursor: 'pointer' } },
                                    _react2.default.createElement("i", {
                                        className: "fa fa-info-circle"
                                    })
                                ),
                                _react2.default.createElement(_reactTooltip2.default, { place: "right", wrapper: "span" })
                            );
                        }

                        var component = _react2.default.createElement(
                            "div",
                            { key: i },
                            _react2.default.createElement(
                                "p",
                                null,
                                charge.name,
                                ": ",
                                descComponent,
                                " ",
                                _react2.default.createElement(
                                    "b",
                                    {
                                        className: "pull-right" },
                                    "$",
                                    chargeFee
                                )
                            )
                        );

                        i = i + 1;
                        return component;
                    });
                } else {
                    return null;
                }
            } else {
                return null;
            }
        }
    }, {
        key: "getCustomChargesOptionalStructureValue",
        value: function getCustomChargesOptionalStructureValue() {

            if (_CustomChargeStore2.default.isCustomChargeConfigured()) {

                // get local optional charges
                var optionalCharges = _CartStore2.default.getDefaultOptionalCharge();

                if (optionalCharges && optionalCharges.length > 0) {
                    // sort the array based on the "chargeObjIdx" key
                    optionalCharges.sort(function (a, b) {
                        return parseFloat(a.chargeObjIdx) - parseFloat(b.chargeObjIdx);
                    });

                    return optionalCharges.map(function (charge, index) {

                        var chargeFee = charge.fee;
                        var chargeLabel = charge.label;

                        var component = _react2.default.createElement(
                            "div",
                            { key: index },
                            _react2.default.createElement(
                                "p",
                                null,
                                chargeLabel,
                                ": ",
                                _react2.default.createElement(
                                    "b",
                                    {
                                        className: "pull-right" },
                                    "$",
                                    chargeFee
                                )
                            )
                        );
                        return component;
                    });
                } else {
                    return null;
                }
            } else {
                return null;
            }
        }
    }, {
        key: "getCustomChargesRoundOffStructureValue",
        value: function getCustomChargesRoundOffStructureValue() {

            var roundOffValue = _CartStore2.default.getRoundOffValue();

            if (roundOffValue != null) {

                var component = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "p",
                        null,
                        "Round Up & Donate: ",
                        _react2.default.createElement(
                            "b",
                            {
                                className: "pull-right" },
                            "$",
                            roundOffValue
                        )
                    )
                );

                return component;
            } else {
                return null;
            }
        }
    }, {
        key: "render",
        value: function render() {

            return _react2.default.createElement(
                "div",
                null,
                this.getCustomChargesFixedStructure(),
                this.getCustomChargesOptionalStructureValue(),
                this.getCustomChargesRoundOffStructureValue()
            );
        }
    }]);

    return CustomChargePriceView;
}(_react2.default.Component);

exports.default = CustomChargePriceView;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/custom-charge/CustomChargePriceView.jsx
// module id = 564
// module chunks = 0